<template>
  <div class="navbar-fixed-jon">
    <div class="navbar-bg" />
    <nav class="navbar navbar-expand-lg main-navbar">
      <form class="form-inline mr-auto">
        <ul class="navbar-nav mr-3">
          <li>
            <a
              href="#"
              data-toggle="sidebar"
              class="nav-link nav-link-lg"
            ><i class="fas fa-bars" /></a>
          </li>
          <li>
            <a
              href="#"
              data-toggle="search"
              class="nav-link nav-link-lg d-lg-none"
            ><i class="fas fa-cog" /></a>
          </li>
        </ul>
        <div
          class="search-element"
          v-if="authService.role.length > 1"
        >
          <!-- <v-select
            id="change-role"
            v-model="currentRole"
            :options="authService.role"
            label="nama_role"
            :reduce="e => e.nama_role"
            :clearable="false"
          /> -->
          <select
            class="form-control"
            style="cursor: pointer"
            v-model="currentRole"
          >
            <option
              v-for="a in authService.role"
              :key="a.id_role"
              :value="a.nama_role"
            >
              {{ a.nama_role }}
            </option>
          </select>
        </div>
      </form>
      <ul class="navbar-nav navbar-right">
        <li class="dropdown dropdown-list-toggle">
          <a
            href="#"
            data-toggle="dropdown"
            class="nav-link notification-toggle nav-link-lg"
            :class="(notifikasi.length > 0) ? 'beep' : ''"
          ><i class="far fa-bell" /></a>
          <div class="dropdown-menu dropdown-list dropdown-menu-right">
            <div class="dropdown-header">
              Notifikasi
            </div>
            <div
              class="dropdown-list-content dropdown-list-icons"
              v-if="notifikasi.length > 0"
            >
              <router-link
                :to="'/permohonan/detail-permohonan/'+n.data.data.permohonan_id"
                class="dropdown-item"
                v-for="n in notifikasi"
                active-class="active-disabled"
                :key="n.id"
              >
                <div class="dropdown-item-icon bg-info text-white">
                  <i class="fas fa-bell" />
                </div>
                <div class="dropdown-item-desc">
                  <b>{{ n.data.notification.title }}</b>
                  <p>{{ n.data.notification.body }}</p>
                  <div class="time">
                    {{ n.created_at }}
                  </div>
                </div>
              </router-link>
            </div>
            <div
              class="dropdown-list-content dropdown-list-icons text-center"
              v-else
            >
              <span class="text-muted">Tidak ada data</span> 
            </div>
            <div
              class="dropdown-footer text-center"
              v-if="notifikasi.length > 0"
            >
              <button
                class="btn btn-link"
                @click="clearNotifikasi"
              >
                Tandai semua sudah dibaca
              </button>
            </div>
          </div>
        </li>
        <li class="dropdown">
          <a
            href="#"
            data-toggle="dropdown"
            class="nav-link dropdown-toggle nav-link-lg nav-link-user"
          >
            <img
              v-if="user"
              alt="image"
              :src="(user.foto) ? $store.getters.getBaseUrl + '/api/file/' + user.foto : require('@/assets/stisla/img/avatar/avatar-1.png')"
              class="rounded-circle mr-1"
            >
            <div class="d-sm-none d-lg-inline-block">{{ (profile) ? profile.nama_lengkap : '' }}</div></a>
          <div class="dropdown-menu dropdown-menu-right">
            <!-- <div class="dropdown-title">Logged in 5 min ago</div> -->
            <router-link
              to="/profil"
              class="dropdown-item has-icon"
            >
              <i class="far fa-user" /> Profil
            </router-link>
            <!-- <a href="features-activities.html" class="dropdown-item has-icon">
                    <i class="fas fa-bolt"></i> Activities
                </a>
                <a href="features-settings.html" class="dropdown-item has-icon">
                    <i class="fas fa-cog"></i> Settings
                </a> -->
            <div class="dropdown-divider" />
            <a
              href="javascript:void(0)"
              class="dropdown-item has-icon text-danger"
              @click="logoutUser"
            >
              <i class="fas fa-sign-out-alt" /> Logout
            </a>
          </div>
        </li>
      </ul>
    </nav>
  </div>
</template>

<style scoped>
    nav.navbar-light {
        background: white;
        border: 1px solid #ddd;
    }
    .search-element select option {
        color: black
    }
    .navbar-fixed-jon {
        position: fixed;
        top: 0;
        z-index: 9;
        width: 100%;
    }
    .navbar-bg {
        height: 70px;
    }
    @media (max-width: 575.98px){
        .navbar .form-inline .search-element .form-control {
            width:calc(100% - 9px) !important;
            border-radius: 3px;
        }
    }

</style>

<script>
import swal from 'sweetalert'
import encrypt from './../../mixins/encrypt'

export default {
  data() {
    return {
      changeRoleTo: ''
    }
  },
  mixins: [encrypt],
  computed: {
    authService() {
      return this.$store.getters.getAuthService
    },
    currentRole: {
      get() {
        return this.$store.getters.getAuthService.currentRole.nama_role
      },
      set(newVal) {
        this.changeRoleTo = newVal
        // this.$store.dispatch('changeRole', this.changeRoleTo)
        // this.$router.push({path: '/home'})
        // console.log(this.changeRoleTo)


        let authService = this.authService
        let role = authService.role
        let newRole = null
        role.forEach(e => {
          if (e.nama_role === this.changeRoleTo) {
            newRole = e
          }
        })

        authService.currentRole = newRole
        authService.token = this.encrypt(authService.token)
        // console.log(authService)
        this.$store.dispatch('setAuthService', authService)

        window.location.href = '/home'
      }
    },
    user() {
      return this.$store.getters.getUser
    },
    profile() {
      return this.$store.getters.getUserProfile
    },
    notifikasi() {
      return (this.$store.getters.getNotifikasi) ? this.$store.getters.getNotifikasi.filter(e => e.data.data) : []
    }
  },
  methods: {
    logoutUser() {
      const loader = document.createElement('div')
      loader.innerHTML = '<div class="overlay-page-loader"><div class="spinner"></div></div>'
      document.querySelector('#app').appendChild(loader)
      this.$store.dispatch('logoutUser').then((res) => {
        if (res.data.status) {
          localStorage.removeItem('authService')
          localStorage.removeItem('fcmToken')
          sessionStorage.clear()
          window.location.href = '/login'
        }
      }).catch((err) => {
        swal({
          title: "Gagal",
          text: "Ada kesalahan teknis. Coba lagi nanti",
          icon: "error",
          buttons: "Ok"
        })
      })
    },
    getNotifikasi() {
      this.$store.dispatch('fetchNotifikasi').then(res => {
        if (res.data.status) {
          let notif = res.data.data
          let created_at = ''
          let date = ''

          notif.forEach(e => {
            date = new Date(e.created_at)
            created_at = date.toLocaleDateString('id-ID', { year: 'numeric', month: 'short', day: 'numeric' })
            created_at += ' ' + date.toLocaleTimeString('it-IT')
            e.created_at = created_at
          })

          this.$store.dispatch('setNotifikasi', notif)
        }
      })
    },
    clearNotifikasi() {
      this.$store.dispatch('clearNotifikasi', true).then(res => {
        if (res.data.status) {
          this.getNotifikasi()
        }
      })
    }
  },
  created() {
    this.getNotifikasi()
  }
}
</script>